export const YOUTUBE = 'YOUTUBE';
export const VINYL = 'VINYL';
